import React, { useState } from "react";
import { classNames, secondsToReadableString } from "maven-lib/dist/utils/misc";
import { useInterval } from "../../hooks";

interface CrTimerProps {
  title: string;
  remainSeconds: () => number;
  busy: boolean;
  disabled: boolean;
  onClick?: () => void;
  onTick: (secs: number) => void;
}

export function CrTimer(props: CrTimerProps) {
  const { title, busy, disabled, remainSeconds, onClick, onTick } = props;

  const [remainTime, setRemainTime] = useState(secondsToReadableString(remainSeconds()));

  useInterval(() => {
    const rs = remainSeconds();

    setRemainTime(secondsToReadableString(rs));

    onTick(rs);
  }, 1000);

  return (
    <>
      {remainTime && (
        <button className={classNames("timer", busy && "--busy", disabled && "--disabled")} title={title} onClick={onClick}>
          {remainTime}
        </button>
      )}
    </>
  );
}
